<template lang="pug">
    div.video-player-control(:class='theClass')
        video.video-js(ref='videoPlayer')
</template>

<script>
import videojs from 'video.js'
videojs.options.autoSetup = false
const env = window.addiesaas?.config?.env
const logLevel = env === 'production' ? 'off' : 'all'
videojs.log.level(logLevel)

import 'video.js/dist/video-js.css'

export default {
    name: 'video-player-control',
    props: {
        asset: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            default() {
                return {}
            },
        },
        playing: {
            type: Boolean,
            default: false,
        },
        fillMode: {
            type: Boolean,
            default: false,
        },
        clickToPlay: {
            type: Boolean,
            default: true,
        },
        hideControls: {
            type: Boolean,
            default: false,
        },
        showCenterButtons: {
            type: Boolean,
            default: false,
        },
        clip: {}
    },
    data() {
        return {
            player: null,
            isPlaying: false,
            duration: 0,
            dimensions: {
                width: null,
                height: null,
            }
        }
    },
    computed: {
        optionsAll() {
            return {
                sources: [
                    {
                        src: this.asset.url,
                        type: this.asset.mimeType,
                    },
                ],
                controls: true,
                fluid: !this.fillMode,
                fill: this.fillMode,
                ...this.options,
                ..._.omitBy(this.$attrs, i => _.isNil(i)),
            }
        },
        theClass() {
            return {
                'video-player-control--fill-mode': this.fillMode,
                'video-player-control--no-click-to-play': !this.clickToPlay,
                'video-player-control--hide-controls': this.hideControls,

                'video-player-control--player-playing': this.isPlaying,
                'video-player-control--player-paused': !this.isPlaying,
                'video-player-control--show-center-buttons': this.showCenterButtons,
            }
        },
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.optionsAll)
        this.player.on('error', () => this.error())
        this.player.on('play', () => this.updatePlaying(true))
        this.player.on('pause', () => this.updatePlaying(false))
        this.player.on('loadedmetadata', () => this.playerMetaReady())
        this.player.on('ready', () => this.playerReady())
        this.player.on('timeupdate', () => this.playerTimeUpdated())
        this.player.on('resize', () => this.$emit('resize'))
        this.player.setInterval(this.mayClipPlayback, 500)

        const clickHandlerEl = document.createElement('div')
        clickHandlerEl.classList.add('video-player-control__click-handler')
        clickHandlerEl.addEventListener('click', this.videoClick)
        this.player.el_.insertBefore(clickHandlerEl, this.player.el_.childNodes[0])
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },

    methods: {
        play() {
            this.player.play()
        },
        pause() {
            this.player.pause()
        },
        moveTo(time) {
            this.player.currentTime(time)
        },
        reset() {
            this.player.currentTime(0)
        },
        error() {
            const error = this.player.error()
            this.$emit('error', error, this.player, this)
        },

        updatePlaying(playing) {
            this.isPlaying = playing
            this.$emit('update:playing', playing)
            this.$emit(playing ? 'playing' : 'paused', this.player, this)
        },
        videoClick() {
            this.$emit('click')
        },
        playerReady() {
            this.$emit('ready', this.player, this)
        },
        playerTimeUpdated() {
            this.$emit('timeupdate', this.player.currentTime(), this.player, this)
        },
        playerMetaReady() {
            const player = this.player
            const meta = {
                duration: player.duration(),
                width: player.videoWidth(),
                height: player.videoHeight(),
            }
            this.duration = meta.duration
            this.dimensions = _.omit(meta, ['duration'])
            this.$emit('meta', meta, this.player, this)
        },
        mayClipPlayback() {
            if (this.isPlaying && this.clip) {
                const isLoop = this.player.loop()
                if (isLoop) {
                    const clipStart = this.clip?.start
                    const clipEnd = this.clip?.end
                    if (clipStart || clipEnd) {
                        const currentTime = this.player.currentTime()
                        if ((clipEnd && currentTime > clipEnd) || (clipStart && currentTime < clipStart)) {
                            this.player.currentTime(clipStart || 0)
                        }
                    }
                }

            }
        }
    },
}
</script>
